import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftInactive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 26,
	viewBox: "0 0 14 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.15384 3.8506e-05C9.01607 3.8506e-05 8.87821 0.074716 8.77312 0.224074L0.157752 12.4594C-0.0525841 12.7579 -0.0525841 13.2421 0.157752 13.5407L8.77312 25.776C8.87819 25.9253 9.01606 26 9.15384 26H13.4615C13.5993 26 13.7372 25.9253 13.8422 25.776C14.0526 25.4774 14.0526 24.9932 13.8422 24.6946L5.60649 12.9981L13.8422 1.30537C14.0526 1.0068 14.0526 0.522577 13.8422 0.224036C13.7372 0.0746813 13.5993 0 13.4615 0L9.15384 3.8506e-05Z",
		fill: "#DCDCDC"
	})
});
export default SvgLeftInactive;
